import { render, staticRenderFns } from "./guessLike.vue?vue&type=template&id=7aeffa5a&scoped=true&"
import script from "./guessLike.vue?vue&type=script&lang=js&"
export * from "./guessLike.vue?vue&type=script&lang=js&"
import style0 from "./guessLike.vue?vue&type=style&index=0&id=7aeffa5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeffa5a",
  null
  
)

component.options.__file = "guessLike.vue"
export default component.exports